export const buildCreateSaleRequestData = (payload) => {
  const input = payload && typeof payload === 'object' ? { ...payload } : {};
  const hasQuoteFile = input.quote_mode === 'file' && input.quote_file instanceof File;

  if (!hasQuoteFile) {
    return input;
  }

  const formData = new FormData();

  Object.entries(input).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      return;
    }

    if (key === 'quote_file' && value instanceof File) {
      formData.append(key, value);
      return;
    }

    if (Array.isArray(value) || (typeof value === 'object' && !(value instanceof Date) && !(value instanceof File))) {
      formData.append(key, JSON.stringify(value));
      return;
    }

    formData.append(key, String(value));
  });

  return formData;
};

export const buildUpdateSaleRequestData = (payload) => buildCreateSaleRequestData(payload);
